// Máscaras de digitação: a pessoa só digita números, a tela formata enquanto ela digita.

/** "27999990000" → "(27) 99999-0000"; vai formatando conforme os dígitos chegam. */
export function mascaraTelefone(texto: string): string {
  let d = texto.replace(/\D/g, '');
  if (d.length > 11 && d.startsWith('55')) d = d.slice(2);
  d = d.slice(0, 11);
  if (d.length === 0) return '';
  if (d.length <= 2) return `(${d}`;
  const ddd = d.slice(0, 2);
  const resto = d.slice(2);
  if (resto.length <= 4) return `(${ddd}) ${resto}`;
  // 8 dígitos = fixo (4-4); 9 = celular (5-4).
  const corte = resto.length === 9 ? 5 : 4;
  return `(${ddd}) ${resto.slice(0, corte)}-${resto.slice(corte)}`;
}

/** Teto do campo de dinheiro: 8 dígitos = R$ 999.999,99 (cabe folgado no integer do banco). */
export const MAX_DIGITOS_DINHEIRO = 8;

/** Moeda "de caixa registradora": cada dígito entra pela direita. "1150" → 1150 centavos. */
export function centavosDeDigitos(texto: string): number | null {
  const d = texto.replace(/\D/g, '').replace(/^0+(?=\d)/, '');
  if (d === '') return null;
  return Number(d.slice(0, MAX_DIGITOS_DINHEIRO));
}

/** Teto do "Cliente paga com": 6 dígitos de reais (R$ 999.999). */
const MAX_DIGITOS_NOTA = 6;

/**
 * "Cliente paga com" digita a nota em reais, não em centavos: "150" → 15000 (R$ 150,00). Com vírgula ou
 * ponto vale a parte decimal ("50,50" → 5050). null quando não há número.
 */
export function centavosDeNota(texto: string): number | null {
  const limpo = texto.replace(/[R$\s ]/g, '');
  if (/[.,]/.test(limpo)) {
    const [inteiro = '', decimal = ''] = limpo.replace(/\.(?=\d{3}(\D|$))/g, '').split(/[.,]/);
    const reais = inteiro.replace(/\D/g, '').slice(0, MAX_DIGITOS_NOTA);
    const cents = decimal.replace(/\D/g, '').slice(0, 2).padEnd(2, '0');
    if (reais === '' && /^0*$/.test(cents)) return null;
    return Number(reais || '0') * 100 + Number(cents);
  }
  const d = limpo.replace(/\D/g, '').replace(/^0+(?=\d)/, '');
  if (d === '') return null;
  return Number(d.slice(0, MAX_DIGITOS_NOTA)) * 100;
}

/** Sigla do estado: só letras, maiúsculas, no máximo 2. "es" → "ES"; "e1s" → "ES". */
export function mascaraUf(texto: string): string {
  return texto
    .normalize('NFD')
    .replace(/[^a-zA-Z]/g, '')
    .slice(0, 2)
    .toUpperCase();
}

/** 1150 → "11,50"; 123456 → "1.234,56". Sem "R$" (o rótulo do campo diz a moeda). */
export function formatarCentavosCampo(centavos: number | null): string {
  if (centavos == null) return '';
  const reais = Math.floor(centavos / 100);
  const resto = String(centavos % 100).padStart(2, '0');
  return `${reais.toLocaleString('pt-BR')},${resto}`;
}

/** Para comparar nomes sem acento e sem maiúscula ("João" acha "joao"). */
export function normalizarBusca(texto: string): string {
  return texto
    .normalize('NFD')
    .replace(/\p{Diacritic}/gu, '')
    .toLowerCase()
    .trim();
}
